export default __webpack_public_path__ + "static/overlook-fff9412c3efd9f5bd359ea9bb5b6b734.jpg";